var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "CenterOnParent",
            [_c("Spinner", { attrs: { type: "secondary" } })],
            1
          )
        : _vm.errorLoading
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [_vm._v("\n    " + _vm._s(_vm.$t("surveyErrorLoading")) + "\n  ")]
          )
        : [
            _c(
              "div",
              { staticClass: "float-right mr-2" },
              [
                _vm._v("\n      " + _vm._s(_vm.$t("language")) + "\n      "),
                _c("vSelect", {
                  staticClass: "d-inline-block",
                  staticStyle: { "min-width": "15em" },
                  attrs: {
                    options: _vm.languages,
                    label: "text",
                    reduce: e => e.locale,
                    clearable: false
                  },
                  model: {
                    value: _vm.selectedLanguage,
                    callback: function($$v) {
                      _vm.selectedLanguage = $$v
                    },
                    expression: "selectedLanguage"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.isUserCheckOverride
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "sd-container-modern",
                      staticStyle: { "padding-top": "40px" }
                    },
                    [
                      _c("div", { staticClass: "sd-hidden" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sd-title sd-container-modern__title" },
                        [_c("h3", [_vm._v(" " + _vm._s(_vm.$t("surveyExit")))])]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "sd-hidden" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "sv-components-row" }, [
                        _c("div", { staticClass: "sd-body sd-body--static" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "sv-components-column sv-components-column--expandable"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sv-string-viewer sv-string-viewer--multiline"
                                },
                                [_vm._v(_vm._s(_vm.$t("firstname")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sd-text__content sd-question__content"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userCheck.firstname,
                                        expression: "userCheck.firstname"
                                      }
                                    ],
                                    staticClass: "sd-input sd-text",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm
                                        .$t("surveyInput")
                                        .toString()
                                    },
                                    domProps: {
                                      value: _vm.userCheck.firstname
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.userCheck,
                                          "firstname",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sv-string-viewer sv-string-viewer--multiline",
                                  staticStyle: { "padding-top": "40px" }
                                },
                                [_vm._v(_vm._s(_vm.$t("lastname")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sd-text__content sd-question__content"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userCheck.lastname,
                                        expression: "userCheck.lastname"
                                      }
                                    ],
                                    staticClass: "sd-input sd-text",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm
                                        .$t("surveyInput")
                                        .toString()
                                    },
                                    domProps: { value: _vm.userCheck.lastname },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.userCheck,
                                          "lastname",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-primary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isSearchButtonDisabled
                        },
                        on: { click: _vm.onCheck }
                      },
                      [_vm._v(_vm._s(_vm.$t("btnOk")))]
                    )
                  ])
                ])
              : _c("survey", {
                  attrs: {
                    survey: _vm.survey,
                    css: { navigationButton: "btn " }
                  }
                })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }